export default {
  NonLegacy: 'trmsV2',
  Legacy: 'trmsV1',
}
